import { AgendaHistoryAudit } from './model';

export interface DetailsAgendaState {
  readonly selectedHistoryId: number;
  readonly plannedOnDate: Date | string;
  readonly plannedOnTime: string;
  readonly agendaReference: string;
  readonly status: string;
  readonly agendaHistoryAuditList: AgendaHistoryAudit[];
}

export const enum DetailsAgendaActionTypes {
  FETCH_AGENDA = '@@detailsAgenda/FETCH_AGENDA',
  FETCH_AGENDA_FAIL = '@@detailsAgenda/FETCH_AGENDA_FAIL',
  FETCH_AGENDA_SUCCESS = '@@detailsAgenda/FETCH_AGENDA_SUCCESS',
  UPDATE_AGENDA = '@@detailsAgenda/UPDATE_AGENDA',
  UPDATE_AGENDA_SUCESS = '@@detailsAgenda/UPDATE_AGENDA_SUCESS',
  UPDATE_AGENDA_FAIL = '@@detailsAgenda/UPDATE_AGENDA_FAIL',
  USE_AGENDA_FROM_HISTORY = '@@detailsAgenda/USE_AGENDA_FROM_HISTORY',
  USE_AGENDA_FROM_HISTORY_SUCESS = '@@detailsAgenda/USE_AGENDA_FROM_HISTORY_SUCESS',
  USE_AGENDA_FROM_HISTORY_FAIL = '@@detailsAgenda/USE_AGENDA_FROM_HISTORY_FAIL',
  RESET_HISTORY_SELECTION = '@@detailsAgenda/RESET_HISTORY_SELECTION',
  RESET_STATE = '@@detailsAgenda/RESET_STATE',
  UPDATE_AGENDA_STATE = '@detailsAgenda/UPDATE_AGENDA_STATE'
}
